export default __webpack_public_path__ + "assets/78f3151b3b137bbf3b5a4ad59c3391cb.png";